import React, { useState } from 'react';
import { useTable } from '../context/TableContext';
import { useOutlet } from '../../context/OutletContext';
import { addDoc, collection, updateDoc, doc, deleteDoc } from 'firebase/firestore';
import { db } from '../../admin/firebase/config';

const TableManagement = () => {
  const { tables } = useTable();
  const { selectedOutlet } = useOutlet();
  const [showAddForm, setShowAddForm] = useState(false);
  const [newTable, setNewTable] = useState({
    tableNumber: '',
    capacity: 4,
    floor: 'Ground Floor',
    section: 'Main Area'
  });

  const handleAddTable = async () => {
    if (!selectedOutlet) {
      alert('No outlet selected');
      return;
    }

    await addDoc(collection(db, 'tables'), {
      ...newTable,
      status: 'available',
      outletId: selectedOutlet.id,
      createdAt: new Date()
    });
    setShowAddForm(false);
    setNewTable({ tableNumber: '', capacity: 4, floor: 'Ground Floor', section: 'Main Area' });
  };

  const handleDeleteTable = async (tableId) => {
    if (window.confirm('Delete this table?')) {
      await deleteDoc(doc(db, 'tables', tableId));
    }
  };

  const handleStatusChange = async (tableId, newStatus) => {
    try {
      await updateDoc(doc(db, 'tables', tableId), {
        status: newStatus,
        updatedAt: new Date()
      });
    } catch (error) {
      console.error('Error updating table status:', error);
      alert('Failed to update table status');
    }
  };

  return (
    <div className="table-management">
      <div className="header">
        <h1>Table Management</h1>
        <button onClick={() => setShowAddForm(true)}>+ Add Table</button>
      </div>

      {showAddForm && (
        <div className="add-table-form">
          <input 
            placeholder="Table Number"
            value={newTable.tableNumber}
            onChange={(e) => setNewTable({...newTable, tableNumber: e.target.value})}
          />
          <input 
            type="number"
            placeholder="Capacity"
            value={newTable.capacity}
            onChange={(e) => setNewTable({...newTable, capacity: parseInt(e.target.value)})}
          />
          <select 
            value={newTable.floor}
            onChange={(e) => setNewTable({...newTable, floor: e.target.value})}
          >
            <option>Ground Floor</option>
            <option>First Floor</option>
            <option>Outdoor</option>
          </select>
          <button onClick={handleAddTable}>Add</button>
          <button onClick={() => setShowAddForm(false)}>Cancel</button>
        </div>
      )}

      <div className="tables-grid">
        {tables.map(table => (
          <div key={table.id} className={`table-card ${table.status}`}>
            <h3>Table {table.tableNumber}</h3>
            <p>Capacity: {table.capacity} people</p>
            <p>Floor: {table.floor}</p>
            <p>Section: {table.section}</p>
            <div className="status">
              Status: <select 
                value={table.status}
                onChange={(e) => handleStatusChange(table.id, e.target.value)}
              >
                <option value="available">Available</option>
                <option value="occupied">Occupied</option>
                <option value="reserved">Reserved</option>
                <option value="cleaning">Cleaning</option>
              </select>
            </div>
            <button onClick={() => handleDeleteTable(table.id)}>Delete</button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TableManagement;
